module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"EmptyCart":{"button":{"ariaLabel":"Odstranit všechny položky z košíku","text":"Vysypat košík"}}},"en":{"EmptyCart":{"button":{"ariaLabel":"Remove all items from your cart","text":"Empty your cart"}}}}')
  delete Component.options._Ctor
}
